module.exports = function() {
  return new Worker(__webpack_public_path__ + "a1bedab3a0504aefffbd.worker.js");
};